// extracted by mini-css-extract-plugin
export default {"resolveFailure":"ecBKN","formSection":"sEISu","requiredLabel":"gkprQ","formActions":"VpL0G","formBtn":"drk5C","clockSelect":"ohgYt","container":"eKbjp"};